import banner1 from './images/banner1.png'
import banner2 from './images/banner2.png'
import banner3 from './images/banner3.png'
import banner4 from './images/banner4.jpg'
import DoChayBo from './images/DoChayBo.png'
import QuanDai from './images/QuanDai.png'
import TatCaSP from './images/TatCaSP.png'
import GiamGia from './images/GiamGia.png'
import MacHangNgay from './images/MacHangNgay.png'
import DoTheThao from './images/DoTheThao.png'
import DoLot from './images/DoLot.png'
import voucher from './images/voucher.png'


const images={
   banner1:banner1,
   banner2:banner2,
   banner3:banner3,
   banner4:banner4,
   DoChayBo:DoChayBo,
   QuanDai: QuanDai,
   voucher: voucher,

}
export const imgCategory = {
   TatCaSP: TatCaSP,
   GiamGia: GiamGia,
   MacHangNgay:MacHangNgay,
   DoTheThao:DoTheThao,
   DoLot:DoLot
}
export default images;